export default __webpack_public_path__ + "5d87709456dcea3b16f44e1298fb6d5e.ogg";